var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-belatedporting-success"},[(this.sim === 'E_SIM')?_vm._t("ceBelatedESim"):_vm._t("ceBelatedSim")],2)}
var staticRenderFns = []

export { render, staticRenderFns }